<template>
  <div class="d-flex">
<!--    <div class="d-flex-left">-->
<!--      <erp-tree-status @node-click="nodeClick" height="70vh" />-->
<!--    </div>-->
    <div class="d-flex-right">
      <div>
        <div class="search-wrap">
          <el-button size="mini" @click="search">查询</el-button>
<!--          <el-button size="mini" @click="edit()" style="margin-right: 5px;" icon="el-icon-plus"  v-if="ERP.isPermission(4007002001)||ERP.isPermission(21004001001)||ERP.isPermission(8006001001)">添加</el-button>-->
        </div>

        <div style="margin-bottom: 10px;">
          <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
            <el-descriptions-item label="仪表类型">
              <el-select size="mini" style="width: 100%" v-model="where.meter_type" clearable filterable placeholder="类型" class="kuan" @change="pageChange(1)">
                <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="当前房产">
              <el-input size="mini" placeholder="请选择房产" v-model="where.house_name" clearable @change="pageChange(1)"></el-input>
<!--              <el-autocomplete size="mini"-->
<!--                               style="min-width: 400px;max-width: 100%"-->
<!--                               v-model="where.house_name"-->
<!--                               :fetch-suggestions="querySearchAsyncRoom2"-->
<!--                               placeholder="请输入房产"-->
<!--                               popper-class="autocomplete-room"-->
<!--              ></el-autocomplete>-->
            </el-descriptions-item>
            <el-descriptions-item label="仪表编号">
              <el-input size="mini" placeholder="请输入仪表编号" v-model="where.number" @change="pageChange(1)" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="收费标准">
              <el-select size="mini" style="width: 100%" v-model="where.charging_standard" filterable clearable placeholder="收费标准" class="kuan" @change="pageChange(1)">
                <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="仪表状态">
              <el-checkbox-group v-model="where.status_ids" @change="pageChange(1)">
                <el-checkbox v-for="item in [{name:'在用',val:1},{name:'停用',val:2}]" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <!--        <el-descriptions-item label="线路">-->
            <!--          <el-input size="mini" placeholder="请输入收费对象" v-model="where.line" clearable></el-input>-->
            <!--        </el-descriptions-item>-->
            <el-descriptions-item label="更换的收费标准">
              <el-select size="mini" style="width: 100%" v-model="charging_standard" filterable clearable placeholder="更换的收费标准" class="kuan">
                <el-option v-for="item in house_charge_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="仪表性质">
              <el-checkbox-group v-model="where.meter_nature_ids" @change="pageChange(1)">
                <el-checkbox v-for="item in meter_nature_list" :label="item.val" :key="item.val">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="能耗类型">
              <el-checkbox-group v-model="where.energy_ids" @change="pageChange(1)">
                <el-checkbox v-for="(item,index) in energy_list" :label="item.val" :key="index">{{item.name}}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>
            <el-descriptions-item label="仪表名称">
              <el-input size="mini" placeholder="请输入收费对象" v-model="where.name" clearable @change="pageChange(1)"></el-input>
            </el-descriptions-item>
          </el-descriptions>
        </div>

        <div>
          <el-table v-if="pageData" v-loading="loading" border :data="pageData.list" width="99%" height="47vh"  @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55" fixed></el-table-column>
            <el-table-column prop="number" label="仪表编号 "  width="150" fixed>
              <template slot-scope="scope">
                <el-link type="primary">{{scope.row.number}}</el-link>
              </template>
            </el-table-column>
<!--            <el-table-column prop="id" label="id" width="80"></el-table-column>-->
            <el-table-column prop="house_name" label="房产" width="300"></el-table-column>
            <el-table-column prop="meter_type_name" label="仪表类型" width="100"></el-table-column>
            <el-table-column prop="name" label="仪表名称 " width="200"></el-table-column>
            <!--        <el-table-column prop="line" label="线路 " width="100"></el-table-column>-->
            <el-table-column prop="charging_standard_name" label="收费标准 "  width="250"></el-table-column>
            <el-table-column prop="charging_standard_money" label="费用单价 "  width="100"></el-table-column>
            <el-table-column prop="status" label="是否在用 " width="100">
              <template slot-scope="scope">
                {{scope.row.status===1?'启用':'停用'}}
              </template>
            </el-table-column>

            <el-table-column prop="status" label="是否有上级 " width="100">
              <template slot-scope="scope">
                {{scope.row.upid?'有':'无'}}
              </template>
            </el-table-column>
<!--            <el-table-column label="操作 " width="280">-->
<!--              <template slot-scope="scope">-->
<!--                &lt;!&ndash;            <el-button type="primary" size="mini" icon="el-icon-edit" @click="update(scope.row)" v-if="ERP.isPermission(4007002006)||ERP.isPermission(21004001006)||ERP.isPermission(8006001006)||ERP.isPermission(30006001006)">能耗</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;                <el-button type="primary" size="mini" icon="el-icon-edit" @click="updateEdit(scope.row)" v-if="ERP.isPermission(4007002007)||ERP.isPermission(21004001007)||ERP.isPermission(8006001007)||ERP.isPermission(30006001007)">换表</el-button>&ndash;&gt;-->
<!--&lt;!&ndash;                <el-button type="danger" size="mini" icon="el-icon-delete" @click="meterShifting(scope.row)" v-if="ERP.isPermission(4007002008)||ERP.isPermission(21004001008)||ERP.isPermission(8006001008)||ERP.isPermission(30006001008)">移表</el-button>&ndash;&gt;-->
<!--              </template>-->
<!--            </el-table-column>-->
          </el-table>
        </div>
        <div style="margin-top: 20px;text-align: right;margin-right: 20px;">
          <Page :total="pageData.total*1" :current-page="pageData.page*1" :page-size="pageData.pageSize*1" @on-change="pageChange" show-total />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ErpTreeStatus from "../../../../Common/erp-tree-status";
import MeterHttp from "../../../common/MeterHttp";

export default {
  name: "SelectMeterList",
  inject:['mainObj','componentId','setComponentId','selectMeter'],
  // components: {ErpTreeStatus},
  data(){
    return{
      host_url: "",
      keyword: '',
      loading: false,
      where: {
        meter_type: "",
        house_name: "",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1,2],
        line: "",
        meter_nature: "",
        meter_nature_ids: [1,2,3,4],
        name: "",
        energy_ids:[1,2,3]
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1
      },
      meter_type_list: [],
      house_charge_list:[],
      meter_nature_list:[{name:'分表',val:1},{name:'总表',val:2},{name:'分摊表',val:3},{name:'电力负荷表',val:4}],
      energy_list:[{name:"业主能耗",val:1},{name:"物业能耗",val:2},{name:"分摊能耗",val:3},],
      multipleSelection: [],
      charging_standard: "",
    }
  },
  mounted() {
    const that=this;
    this.host_url = __HTTP__.defaults.baseURL;
    that.where.project_id=that.mainObj.project_id;
    // this.month_value=CommonHelp.date("YYYY-MM");

    that.getMeterTypeList()
    if(that.where.house_name){
      that.getList();
    }
  },
  watch: {
    "where.meter_type":function (n) {
      this.chargeItem_name_ids=(this.meter_type_list.find(ret=>{ return ret.id===n })||{}).expenditure_ids||"";
      this.getHouseChargeList();
    },
    "where.house_name":function (n) {
      const that=this;
      this.where.house_name=n;
      this.getList();
    }
  },
  computed: {
    multipleSelection_meter_type_num(){
      let set=new Set();
      this.multipleSelection.map(ret=>{
        set.add(ret.meter_type)
      });
      return Array.from(set).length;
    }
  },
  methods:{
    nodeClick(data) {
      const that=this;
      that.where.house_name = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      that.where.project_id = data.tree[0].pindex_id;
      if (data.tree[data.tree.length - 1].type === "room") {
        that.where.house_id = data.tree[data.tree.length - 1].id;
      } else {
        that.where.house_id = 0;
      }
    },
    search() {
      this.pageData.page = 1
      this.getList()
      this.multipleSelection = []
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = reObject(this.where);
      // where.is_update=0;
      MeterHttp.get("Meter/getList",{
        project_id:that.mainObj.project_id,
        where: JSON.stringify(where),
        user_type:(that.$route.query.type||0),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      });
    },
    getHouseChargeList(){
      const that = this;
      let where={};
      this.form.project_id&&(where.pindex_id=this.form.project_id);
      this.chargeItem_name_ids&&(where.chargeItem_name_ids=this.chargeItem_name_ids);
      MeterHttp.get("HouseCharge/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      });
    },
    querySearchAsyncRoom(queryString, cb){
      const that=this;
      if(!queryString){
        cb([]);
      }else {
        MeterHttp.post("Meter/getMeterKeyValue?user_type="+(that.$route.query.type||0),{
          keyWord:queryString,
          project_id:that.form.project_id
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    querySearchAsyncRoom2(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        });
      }

    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.selectMeter.meter_list=val;
    },
  }
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
@import "../../../common";
.d-flex {
  display: flex;
  margin: 10px;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/SelectMeterList.vue